import { render, staticRenderFns } from "./sku-attr-dialog.vue?vue&type=template&id=5e1d3da8&"
import script from "./sku-attr-dialog.vue?vue&type=script&lang=js&"
export * from "./sku-attr-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports